const MAX_NUMBER_OF_CHARS_IN_CHIP = 30;

export const getChipLabel = (
    value: string,
    aggregation?: string,
): { isTruncated: boolean; chipLabel: string } => {
    // Simple truncation and ellipsis addition if no aggregation is provided
    if (!aggregation) {
        if (value.length < MAX_NUMBER_OF_CHARS_IN_CHIP)
            return { isTruncated: false, chipLabel: value };
        return {
            isTruncated: true,
            chipLabel: `${value.slice(0, MAX_NUMBER_OF_CHARS_IN_CHIP)}...`,
        };
    }
    // With an aggregation, the ellipsis should be added before the parenthesis surrounding the aggregation
    const aggregationWithParenthesis = `(${aggregation})`;
    const fullValueLength =
        value.length + aggregationWithParenthesis.length + 1;
    if (fullValueLength < MAX_NUMBER_OF_CHARS_IN_CHIP)
        return {
            isTruncated: false,
            chipLabel: `${value} ${aggregationWithParenthesis}`,
        };
    return {
        isTruncated: true,
        chipLabel: `${value.slice(
            0,
            MAX_NUMBER_OF_CHARS_IN_CHIP - aggregationWithParenthesis.length,
        )}...${aggregationWithParenthesis}`,
    };
};
